<template>
    <div class="table">
        <NoData v-if="!customers.length" :type="'leads'" />
        <template v-else>
            <div class="table__header box box--default">
                <div class="table__label table__label--xsmall">
                    <div class="checkbox">
                        <input type="checkbox" id="selectAll" class="checkbox__checkbox" :checked="allSelected"
                            :indeterminate.prop="someSelected" @change="toggleAll">
                        <label for="selectAll" class="checkbox__label"></label>
                    </div>
                </div>
                <div class="table__label table__label--small">
                    {{ $t(`leads.${"tableHeader"}.${"date"}`) }}
                </div>
                <div class="table__label table__label--medium">
                    {{ $t(`leads.${"tableHeader"}.${"status"}`) }}
                </div>
                <div class="table__label table__label--small">
                    {{ $t(`customerLeadsTable.${"header"}.${"referal"}`) }}
                </div>
                <div class="table__label table__label--medium">
                    {{ $t(`leads.${"tableHeader"}.${"name"}`) }}
                </div>
                <div class="table__label table__label--small">
                    {{ $t(`leads.${"tableHeader"}.${"contact"}`) }}
                </div>
                <div class="table__label table__label--medium">
                    Agent
                </div>
                <div class="table__label table__label--small">
                    {{ $t(`leads.${"tableHeader"}.${"zipCode"}`) }}
                </div>
                <div class="table__label table__label--medium">
                    {{ $t(`leads.${"tableHeader"}.${"city"}`) }}
                </div>
                <div class="table__label table__label--small">
                    {{ $t(`leads.${"tableHeader"}.${"deadline"}`) }}
                </div>
                <div class="table__label table__label--medium">
                    {{ $t(`leads.${"tableHeader"}.${"text"}`) }}
                </div>
                <div class="table__label table__label--small"> </div>
                <div class="table__label table__label--small"> </div>
            </div>

            <div class="table__body">
                <div v-for="customer in customers" :key="customer.id">
                    <div @click="routeToCustomer(customer.id)" class="customer row row--hover box box--default">
                        <div @click.stop class="row__data row__data--name row__data--xsmall center-class">
                            <div class="checkbox" @click.stop>
                                <input type="checkbox" :id="'customer-' + customer.id" class="checkbox__checkbox"
                                    :checked="isSelected(customer.id)" @change="toggleCustomer(customer.id)">
                                <label :for="'customer-' + customer.id" class="checkbox__label"></label>
                            </div>
                        </div>
                        <div @click.stop class="row__data row__data--name row__data--small center-class">
                            <span v-if="customer && customer.created_at">{{ formatSimpleDate(customer.created_at)
                                }}</span>
                            <span v-else> ----- </span>
                        </div>
                        <div @click.stop class="row__data row__data--name row__data--medium center-class">
                            <div v-if="customer && customer.customer_sub_status">
                                <span class="status" :class="'status--' + customer.customer_sub_status.id"
                                    v-if="customer.customer_sub_status">{{ customer.customer_sub_status.name }}</span>
                            </div>
                            <span v-else>-----</span>
                        </div>
                        <div @click.stop class="row__data row__data--name row__data--small center-class referal-column">
                            <div v-if="customer.latest_lead && customer.latest_lead.referral">
                                {{ customer.latest_lead.referral.name }}
                            </div>
                            <span v-else>------</span>
                            <div class="referal-note" v-if="customer.latest_lead && customer.latest_lead.referral_note">
                                {{ customer.latest_lead.referral_note }}
                            </div>
                        </div>
                        <div class="row__data row__data--name row__data--medium">
                            <span v-if="customer"> {{ customer.full_name }} </span>
                            <span v-else> ----- </span>
                        </div>
                        <div @click.stop class="row__data row__data--contact row__data--small">
                            <div v-if="customer && getPhone(customer)" class="contact-wrapper">
                                <a class="row__phone icon__phone"
                                    :href="getPhone(customer) ? `tel:${getPhone(customer)}` : 'javascript:void(0)'"
                                    :class="{ 'icon__phone--active': getPhone(customer) }"></a>
                                <a :href="getPhone(customer) ? `tel:${getPhone(customer)}` : 'javascript:void(0)'"
                                    class="tooltip">{{ getPhone(customer) }}</a>
                            </div>
                            <div v-else>
                                <a class="row__phone icon__phone"></a>
                            </div>

                            <div v-if="customer && getEmail(customer)" class="contact-wrapper">
                                <a class="row__mail icon__mail"
                                    :href="getEmail(customer) ? `mailto:${getEmail(customer)}` : 'javascript:void(0)'"
                                    :class="{ 'icon__mail--active': getEmail(customer) }"></a>
                                <a :href="getEmail(customer) ? `mailto:${getEmail(customer)}` : 'javascript:void(0)'"
                                    class="tooltip">{{ getEmail(customer) }}</a>
                            </div>
                            <div v-else>
                                <a class="row__mail icon__mail"></a>
                            </div>
                        </div>

                        <div class="row__data row__data--name row__data--medium">
                            <span v-if="customer.latest_lead && customer.latest_lead.agent"> {{
                                customer.latest_lead.agent.first_name }} {{ customer.latest_lead.agent.last_name }}
                            </span>
                            <span v-else> ----- </span>
                        </div>


                        <div class="row__data row__data--zip row__data--small center-class">
                            <template v-if="customer && getFirstAddress(customer)">
                                {{ getFirstAddress(customer).zip || '----' }}
                            </template>
                            <template v-else>----</template>
                        </div>

                        <div class="row__data row__data--city row__data--medium center-class">
                            <template v-if="customer && getFirstAddress(customer)">
                                {{ getFirstAddress(customer).city || '----' }}
                            </template>
                            <template v-else>----</template>
                        </div>
                        <div class="row__data row__data--date row__data--small center-class">
                            <span v-if="customer.latest_lead && customer.latest_lead.deadline">{{
                                formatSimpleDate(customer.latest_lead.deadline)
                            }}</span>
                            <span v-else> ----- </span>
                        </div>
                        <div  @click.stop class="row__data row__data--date row__data--medium">
                            <EditableComment v-if="customer.latest_lead && customer.latest_lead.comment"
                                :comment="customer.latest_lead.comment" :readonly="true" />
                            <span v-else> ----- </span>
                        </div>
                        <div @click.stop class="row__data row__data--file row__data--small "
                            style="justify-content: space-between !important;">
                            <div class="icon__pdf" v-if="$checkRolePermission('customer_edit')"
                                :class="{ 'icon__pdf--active': customer.latest_lead && customer.latest_lead.files && customer.latest_lead.files.length > 0 }"
                                @click.stop="openLeadFilesModal(customer.latest_lead)">
                            </div>

                            <div v-if="$checkRolePermission('customer_create')" class="action icon icon__add"
                                @click.stop="openAddLeadModal(customer)"></div>
                        </div>
                        <div class="row__data row__data--small row__data--action"
                            v-if="$checkRolePermission('customer_edit') || $checkRolePermission('customer_delete')"
                            @click.stop="toggleActionsDropdown(customer.id)">
                            <RowActionDropdown v-if="showActionsDropdown === customer.id"
                                @toggleDropdown="handleDropdownToggle($event, customer.id)"
                                :onEdit="() => openEditLeadCustomerModal(customer)"
                                :onDelete="() => openDeleteConfirmation(customer.id)" />

                            <transition name="fade">
                                <div class="delete" v-if="activeDeleteId === customer.id" @click.stop>
                                    <div class="delete__text">
                                        {{ $t('deleteModal.question') }} {{ $t('deleteModal.lead') }}?
                                    </div>
                                    <div class="delete__buttons">
                                        <div class="button button--confirm" @click.stop="confirmDelete(customer.id)">
                                        </div>
                                        <div class="button button--cancel" @click.stop="closeDeleteConfirmation">
                                        </div>
                                    </div>
                                </div>
                            </transition>
                        </div>

                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script setup>
import { computed, getCurrentInstance, onMounted, ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import NoData from "@/partials/NoData";
import EditableComment from "@/partials/EditableComment";
import RowActionDropdown from "@/components/RowActionDropdown";

defineOptions({
    name: "LeadsTable"
});

const props = defineProps({
    customers: {
        type: Array,
        required: true,
        default: () => []
    },
    selectedCustomers: {
        type: Array,
        default: () => []
    }
});

const emit = defineEmits([
    'selection-changed',
    'refresh',
    'update:selectedCustomers'
]);

const router = useRouter();
const store = useStore();
const instance = getCurrentInstance();

const showActionsDropdown = ref(null);
const activeDeleteId = ref(null);
const hasMounted = ref(false);
const selectedCustomerIds = ref([...props.selectedCustomers]);

const normalizeId = (value) => Number.parseInt(value, 10);

const allSelected = computed(() => {
    return props.customers.length > 0 && selectedCustomerIds.value.length === props.customers.length;
});

const someSelected = computed(() => {
    return selectedCustomerIds.value.length > 0 && selectedCustomerIds.value.length < props.customers.length;
});

const syncSelection = (nextSelection) => {
    selectedCustomerIds.value = nextSelection;
    emit('selection-changed', nextSelection);
    emit('update:selectedCustomers', nextSelection);
};

watch(
    () => props.selectedCustomers,
    (nextSelection) => {
        if (!Array.isArray(nextSelection)) {
            return;
        }

        selectedCustomerIds.value = [...nextSelection];
    },
    { deep: true, immediate: true }
);

watch(
    () => props.customers,
    (newCustomers) => {
        if (!newCustomers || !Array.isArray(newCustomers)) {
            return;
        }

        if (!hasMounted.value) {
            return;
        }

        selectedCustomerIds.value = [];
        emit('selection-changed', []);
        emit('update:selectedCustomers', []);
    },
    { deep: true, immediate: true }
);

const isSelected = (customerId) => {
    const id = normalizeId(customerId);
    return selectedCustomerIds.value.includes(id);
};

const toggleCustomer = (customerId) => {
    const id = normalizeId(customerId);
    const nextSelection = selectedCustomerIds.value.includes(id)
        ? selectedCustomerIds.value.filter((selectedId) => selectedId !== id)
        : [...selectedCustomerIds.value, id];

    syncSelection(nextSelection);
};

const toggleAll = () => {
    if (allSelected.value) {
        syncSelection([]);
        return;
    }

    syncSelection(props.customers.map((customer) => normalizeId(customer.id)));
};

const clearSelection = () => {
    syncSelection([]);
};

const toggleActionsDropdown = (customerId) => {
    showActionsDropdown.value = showActionsDropdown.value === customerId ? null : customerId;
};

const handleDropdownToggle = (isOpen, customerId) => {
    if (!isOpen) {
        showActionsDropdown.value = null;

        if (activeDeleteId.value === customerId) {
            activeDeleteId.value = null;
        }

        return;
    }

    showActionsDropdown.value = customerId;
};

const routeToCustomer = (customerId) => {
    router.push({
        name: "AccountDetails",
        params: {
            entity: "lead",
            id: customerId,
        },
        query: {
            tab: 10
        }
    });
};

const formatSimpleDate = (dateString) => {
    if (!dateString) return '-----';

    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) {
        return dateString;
    }

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}.${month}.${year}`;
};

const getPhone = (customer) => {
    const phones = customer?.customer_phones;

    if (Array.isArray(phones) && phones.length > 0) {
        return phones[0].phone || phones[0].number || null;
    }

    return null;
};

const getEmail = (customer) => {
    const emails = customer?.customer_emails;

    if (Array.isArray(emails) && emails.length > 0) {
        return emails[0].email || null;
    }

    return null;
};

const getFirstAddress = (customer) => {
    const addresses = customer?.customer_addresses;

    return Array.isArray(addresses) && addresses.length > 0 ? addresses[0] : null;
};

const openLeadFilesModal = (lead) => {
    if (!lead) return;

    store.commit("setShowFilesEditModal", true);
    store.commit("setFilesToEditId", lead.id);
    store.commit("setFilesToEdit", lead.files);
    store.commit("setFilesEditMode", 'Leads');
};

const openAddLeadModal = (customer) => {
    if (!customer) return;

    store.commit("setCustomerDetails", customer);
    store.commit("setCustomerDetailsId", customer.id);
    store.commit("setShowAddLeadModal", true);
};

const openEditLeadCustomerModal = (customer) => {
    if (!customer) return;

    showActionsDropdown.value = null;
    store.commit("setLeadCustomerToEdit", customer);
    store.commit("setShowCustomerLeadModal", true);
};

const openDeleteConfirmation = (customerId) => {
    showActionsDropdown.value = null;
    activeDeleteId.value = customerId;
};

const closeDeleteConfirmation = () => {
    activeDeleteId.value = null;
};

const confirmDelete = async (customerId) => {
    activeDeleteId.value = null;

    try {
        await store.dispatch("deleteLeadCustomer", customerId);
        emit('refresh');
    } catch (err) {
        console.error(err);
    }
};

onMounted(() => {
    hasMounted.value = true;

    const checkRolePermission = instance?.appContext?.config?.globalProperties?.$checkRolePermission;
    const hasAccess = checkRolePermission
        ? checkRolePermission('customer_access') || checkRolePermission('customer_show')
        : true;

    if (!hasAccess) {
        router.push('/dashboard');
    }
});

// Expose methods for parent component access
defineExpose({
    clearSelection
});
</script>

<style scoped lang="scss">
.referal-column {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .referal-note {
        font-size: 0.7em;
        margin-top: 10px;
    }
}

.row__data--xsmall {
    flex: 0 !important;
}

.actions {
    justify-content: space-between !important;
}

.row__data--delete,
.icon__delete,
.row__data--action {
    position: relative;

    .delete {
        position: absolute;
        z-index: 4;
        background: var(--bg-1);
        right: 0%;
        top: 50%;
        transform: translateY(-50%);
        margin-right: 10px;
        width: 330px;
        display: flex;
        align-items: center;
        border-radius: var(--radius-1);
        border: 1px solid var(--border-2);
        padding: 10px 20px;
        box-shadow: 0px 3px 6px var(--shadow-7);

        &__text {
            line-height: 20px;
            color: var(--text-9);
        }

        &__buttons {
            display: flex;
        }

        .button {
            width: 24px;
            height: 24px;
            cursor: pointer;
            transition: all 0.3s ease;

            &--confirm {
                background: url("../assets/icons/default/confirm_icon.svg");
                margin: 0 15px;

                &:hover {
                    background: url("../assets/icons/default/confirm_hover_icon.svg");
                }
            }

            &--cancel {
                background: url("../assets/icons/default/close_icon.svg");

                &:hover {
                    background: url("../assets/icons/default/close_hover_icon.svg");
                }
            }
        }
    }
}

.table .row__phone,
.table .row__mail,
.icon__pdf,
.icon__pdf--active,
.icon__contract,
.icon__edit,
.icon__delete {
    display: block;
    height: 25px;
    width: 25px;
}

.icon__pdf,

.icon__contract,
.icon__edit,
.icon__delete {
    height: 100%;
}

.row__data--contact span {
    display: flex;
}

.center-class {
    justify-content: center !important;
    text-align: center;
}

.status {
    padding: 8px 16px;
    border-radius: 10px;
    text-align: center;

    //new
    &--1 {
        background: #cfcdcda2;
    }

    //open
    &--2 {
        background: #003cff85;
    }

    //need analyse
    &--3 {
        background: #ffae0062;
    }

    //negotiation
    &--4 {
        background: #ff5e007c;
    }

    //won
    &--5 {
        background: #22db8e1a;
    }

    //lost
    &--6 {
        background: #ff00008f;
    }
}

.table .row__phone {
    margin-right: 20px !important;
}

.action-menu-icon {
    font-size: 24px;
    font-weight: bold;
    cursor: pointer;
    color: var(--text-3);
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    transition: all 0.3s ease;

    &:hover {
        background-color: var(--bg-3);
        color: var(--text-1);
    }
}

.row__data--action {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
}

.contact-wrapper {
    position: relative;
    display: inline-block;

    .tooltip {
        visibility: hidden;
        width: 140px;
        word-break: break-word;
        background-color: var(--bg-17);
        color: var(--text-9);
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 6px;
        padding: 8px 5px;
        position: absolute;
        font-size: 0.75em;
        z-index: 1;
        left: 50%;
        transform: translateX(-50%);
        top: -100%;
    }

    &:hover .tooltip {
        visibility: visible;
    }
}
</style>
